// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3758":"800e51d4dc3cb86e","6545":"ff02d1f865cc8a9a","8210":"4efd2afd1cbb261e"}[chunkId] + ".js";
};